<template>
  <Header class="header">
    <div class="content-panel personal-index clearfix">
      <a class="layout-logo pc" href="/">
        <img class="pcImg" alt="ADRAYN" :src="$ComDomain.base + 'static/images/logo_w.png'">
      </a>
      <a class="layout-logo h5" href="javascript:;">
        <img class="mobileImg" alt="ADRAYN" :src="$ComDomain.base + 'static/images/logo.png'">
      </a>
      <div class="layout-nav">
        <a role="button" :class="{nav: true, 'text-success': active(key)}" v-for="(value, key) in navs.nav" :key="key" :href="$ComDomain.Modules[key]" target="_self">{{ value }}</a>
      </div>
      <div class="layout-am-chain">
        <span>AMChain</span>
        <span class="fz-12">当前高度：{{ wsInfo.blockNumber || '--' }}</span>
        <span class="fz-12">出块时间：{{ wsInfo.blockTime || '--' }}</span>
      </div>
      <div class="layout-user-box">
        <UserBox></UserBox>
      </div>
      <div class="right">
        <slot></slot>
      </div>
    </div>
  </Header>
</template>
<script>
import { Header } from 'iview'
import { copyright, navs } from '../../locale'
import UserBox from './UserBox'

export default {
  name: 'layoutHeader',
  data() {
    return {
      navs,
      copyright,
      path: process.env.WsBasePath + '/print/chain/block',
      socket: '',
      wsInfo: {}
    }
  },
  components: {
    Header,
    UserBox
  },
  beforeCreate() {
    window.document.title = copyright.title
  },
  created () {
    this.init();
    // 通过hook监听组件销毁钩子函数
    this.$once('hook:beforeDestroy', () => {
      // 销毁监听
      this.socket.close()
    });
  },
  methods: {
    active(key) {
      return (key == 'index' && window.location.pathname == '/') || (key != 'index' && window.location.pathname.indexOf(global.$ComDomain.Modules[key]) == 0)
    },
    init () {
      if (typeof WebSocket === "undefined") {
        this.$Message.error('您的浏览器不支持socket');
      } else {
        // 实例化socket
        this.socket = new WebSocket(this.path)
        // 监听socket连接
        this.socket.onopen = this.open
        // 监听socket关闭事件
        this.socket.onclose = this.close
        // 监听socket错误信息
        this.socket.onerror = this.error
        // 监听socket消息
        this.socket.onmessage = this.getMessage
      }
    },
    open: function  () {
      console.log("socket连接成功")
    },
    error: function  () {
      console.log("连接错误")
    },
    getMessage: function  (msg) {
      if (msg && msg.data && typeof msg.data === 'string') {
        try {
          this.wsInfo = JSON.parse(msg.data);
        } catch (e) {
          console.error('JSON.parse err: ', e);
        }
      }
    },
    send: function  () {
      // this.socket.send('socket test.')
    },
    close: function () {
      console.log("socket已经关闭")
    }
  }
}

</script>
<style scoped lang="less">
div.header {
  height: 100px;
  color: #fff;
  background: #000;
  line-height: 66px;
  padding: 17px 0;

  a {
    color: #fff;
  }


  .content-panel{
    .layout-logo{
      &.h5{
        display:none;
      }
    }
  }

}

.layout-logo {
  float: left;
  margin-right: 20px;
}
.mobileImg{
  display:none;
}
.layout-nav {
  float: left;
  height: 66px;
  line-height: 66px;
  background: none;

  .nav {
    font-size: 14px;
    margin: 0 30px;
    opacity: 1;
  }
}

.mobile{
  .header{
    width:100%;
    height:1.173rem;
    background-color:#fff;
    display:flex;
    justify-content:space-between;
    align-items:center;
    padding:0 0.533rem;
    line-height:1.6;
    border-bottom: none;
    .content-panel{
      width:100%;
      padding:0;
      .layout-logo{
        &.pc{
          display:none;
        }
        &.h5{
          display:block;
        }
      }
    }
    .pcImg{
      display:none;
    }
    .mobileImg{
      display:block;
      width:3.013rem;
      height:0.613rem;
    }
    .layout-nav{
      display:none;
    }
    .layout-userbox{

    }
  }
}

.layout-am-chain {
  float: left;
  //width: 230px;
  width: 200px;
  height: 80px;
  background: rgba(255, 255, 255, 0.1);
  //margin-left: 220px;
  margin-left: 250px;
  margin-top: -6px;

  span {
    display: block;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi, serif;
    font-weight: 400;
    color: #FFFFFF;
    padding: 10px;
    opacity: 0.7;

    &.fz-12 {
      font-size: 12px;
    }
  }
}

.layout-user-box {
  float: right;
}

</style>



// WEBPACK FOOTER //
// src/commons/components/layout/Header.vue